// Port of api/fuel/app/classes/filter/search/games/rules/query/categories.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'categories',
	isIndex: function() { return 'category' }
})
